import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9e8673cc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e8673cc')) {
      api.createRecord('9e8673cc', component.options)
    } else {
      api.reload('9e8673cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9e8673cc", function () {
      api.rerender('9e8673cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/msg/index.vue"
export default component.exports